// Mirrors src/Domain/Enums/AnalyticalMethodType.cs — serialized as integers (enum value).
export const ANALYTICAL_METHOD_TYPE = Object.freeze({
  SPECIFIC: 0,
  NON_SPECIFIC: 1,
  VISUAL_INSPECTION: 2,
});

export const ANALYTICAL_METHOD_TYPE_LABELS = Object.freeze({
  [ANALYTICAL_METHOD_TYPE.SPECIFIC]: 'Specific',
  [ANALYTICAL_METHOD_TYPE.NON_SPECIFIC]: 'Non-specific',
  [ANALYTICAL_METHOD_TYPE.VISUAL_INSPECTION]: 'Visual Inspection',
});

// Shown under the Method Type picker on the analytical method form.
export const ANALYTICAL_METHOD_TYPE_HINTS = Object.freeze({
  [ANALYTICAL_METHOD_TYPE.SPECIFIC]: 'Identifies and quantifies one residue (e.g. HPLC) — link the target residue below',
  [ANALYTICAL_METHOD_TYPE.NON_SPECIFIC]: 'Detects multiple ingredients (e.g. TOC, conductivity, pH, UV-Vis)',
  [ANALYTICAL_METHOD_TYPE.VISUAL_INSPECTION]: 'Qualitative pass/fail check of the cleaned surface — no instrument technique',
});

// Residue kind for a specific method (mirrors FmecaStep.ResidueType strings).
export const RESIDUE_TYPE = Object.freeze({
  API: 'Api',
  CLEANING_AGENT: 'CleaningAgent',
});
